import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  HostListener,
  Input,
} from '@angular/core';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { TooltipDirective } from '@epicuro-next/ataraxia/tooltip';
import { dynamicElementsSortHeaderKey } from '@epicuro-next/constants/dynamic-elements';
import { DontTreeShake } from '@epicuro-next/elements/core';
import { SortDirection, SortParamsOfType } from '@epicuro-next/models/sorting';
import { dispatchDynamicEvent } from '@epicuro-next/platform/dynamic-actions';
import { DynamicComponentRegister } from '@epicuro-next/platform/dynamic-components-registrator';

@DynamicComponentRegister(dynamicElementsSortHeaderKey, true)
@Component({
  selector: 'epc-dynamic-elements-sort-header',
  imports: [CommonModule, IconsModule, TooltipDirective],
  templateUrl: './sort-header.component.html',
  styleUrls: ['./sort-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DynamicElementsSortHeaderComponent {
  public ascDirection = SortDirection.Asc.toLowerCase();
  public descDirection = SortDirection.Desc.toLowerCase();

  @Input()
  public text = '';

  @Input()
  public action: {
    type: string;
    value: string;
  } | null = null;

  @Input()
  public currentSort: SortParamsOfType<string> | null = null;

  @HostBinding('class.truncate')
  @Input()
  public truncate!: boolean;

  @Input()
  public tooltip!: string;

  @HostListener('click', ['$event'])
  public onClick(event: MouseEvent) {
    event.stopPropagation();
    if (!this.action) {
      return;
    }

    dispatchDynamicEvent(this.action.type, this.action.value);
  }
}

DontTreeShake(DynamicElementsSortHeaderComponent);
